import { addDays, formatISO } from "date-fns";

export function getScheduleResumeDefaultDate(): string {
    return formatISO(addDays(new Date(), 1), { representation: "date" });
}

export function clampToUnlocked(
    dateOnly: string,
    firstUnlockedDate?: string,
): string {
    return firstUnlockedDate && dateOnly < firstUnlockedDate
        ? firstUnlockedDate
        : dateOnly;
}
